import { REQUEST_STATUS } from '@/constants/request-status'

export function getStatusColorById(id?: string) {
  if (id) {
    const iterable = Object.values(REQUEST_STATUS)
    const found = iterable.find((item) => item.id === id)

    return found ? found.color : ''
  }

  return ''
}
